import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useCart } from '../context/CartContext';

function Checkout() {
  const navigate = useNavigate();
  const { cartItems, getCartTotal, clearCart } = useCart();

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    address: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (cartItems.length === 0) {
      return;
    }
    clearCart();
    navigate('/success');
  };

  if (cartItems.length === 0) {
    return (
      <div className="container" style={{ textAlign: 'center', padding: '80px 0' }}>
        <Helmet>
          <title>Kassen - HeroPixelLab</title>
        </Helmet>
        <h2 style={{ color: '#00e5ff', marginBottom: '20px' }}>Din handlekurv er tom</h2>
        <p style={{ color: '#e0e0e0' }}>Du må ha produkter i handlekurven for å gå til kassen.</p>
        <div className="page-number">Side 7</div>
      </div>
    );
  }

  return (
    <div className="container" style={{ padding: '60px 0' }}>
      <Helmet>
        <title>Kassen - HeroPixelLab</title>
        <link href="https://heropixellab.com/checkout/" rel="canonical"/>
      </Helmet>
      <h1 className="checkout-title">Kasse</h1>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '40px', alignItems: 'start' }}>
        <form className="checkout-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="firstName">Fornavn</label>
            <input
              type="text"
              id="firstName"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="lastName">Etternavn</label>
            <input
              type="text"
              id="lastName"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">E-post</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="phone">Telefon</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="address">Adresse</label>
            <input
              type="text"
              id="address"
              name="address"
              value={formData.address}
              onChange={handleChange}
              required
            />
          </div>
          <button type="submit" className="submit-button">Fullfør Bestilling</button>
        </form>

        <div style={{ background: '#1a1225', border: '1px solid #9b59b6', borderRadius: '20px', padding: '30px' }}>
          <h3 style={{ color: '#00e5ff', marginBottom: '20px' }}>Din Bestilling</h3>
          {cartItems.map((item) => (
            <div key={item.id} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px', borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: '15px' }}>
              <span style={{ color: '#e0e0e0' }}>{item.name} (x{item.quantity})</span>
              <span style={{ color: '#00e5ff' }}>kr {item.price * item.quantity},-</span>
            </div>
          ))}
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '20px', fontWeight: '700', marginTop: '20px' }}>
            <span style={{ color: '#e0e0e0' }}>Total:</span>
            <span style={{ color: '#00e5ff' }}>kr {getCartTotal()},-</span>
          </div>
        </div>
      </div>

      <div className="page-number">Side 7</div>
    </div>
  );
}

export default Checkout;